import { render, staticRenderFns } from "./SuspectedPlayers.vue?vue&type=template&id=eb717776&scoped=true&"
import script from "./SuspectedPlayers.vue?vue&type=script&lang=js&"
export * from "./SuspectedPlayers.vue?vue&type=script&lang=js&"
import style0 from "./SuspectedPlayers.vue?vue&type=style&index=0&id=eb717776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb717776",
  null
  
)

export default component.exports